import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import GlobalSettings from "../../WidgetsSettings/GlobalSettings/GlobalSettingsModal";
import "../../WidgetsSettings/GlobalSettings/GlobalSettings.less";
import SectionSettings from "../../WidgetsSettings/SectionWidget/SectionSettings";
import { BenefitsChartSettings } from "./BenefitsChartSettings";
import { useIntl } from "react-intl";

type BenefitsChartModalProps = {
   value: any;
   data: any;
};

export const BenefitsChartModal = ({ value, data }: BenefitsChartModalProps) => {
   const intl = useIntl();

   return (
      <Tabs defaultActiveKey="globalSettings">
         <TabPane tab={intl.formatMessage({ id: "settings.widgetSettings" })} key="globalSettings">
            <GlobalSettings value={value} />
         </TabPane>
         <TabPane tab={intl.formatMessage({ id: "settings.listSettings" })} key="listSettings">
            <BenefitsChartSettings value={value} />
         </TabPane>
      </Tabs>
   );
};
